import React from 'react';
import { DashboardLayout } from '../../components/dashboard';
import { AIProviderSettings } from '../../components/admin/AIProviderSettings';
import { AiOpsSections } from '../../features/ai-ops';
import { MonitoringThresholdsSection } from '../../features/monitoring/components/MonitoringThresholds';
import { MailSettingsSection } from './MailSettingsSection';
import { Page } from '../../components/ui';

export const AISettingsPage: React.FC = () => {
  return (
    <DashboardLayout>
      <AIProviderSettings />
      <Page>
        <AiOpsSections className="mt-8" />
        <MonitoringThresholdsSection className="mt-8" />
        <MailSettingsSection className="mt-8" />
      </Page>
    </DashboardLayout>
  );
};
